import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class DeskLegsToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {
    public map(element: Element): ISimpleSapElement[] {
        const code = this.toLegsType(element);
        const type = this.formatType(code, 7, 2);
        return [SimpleSapElement.LEG(type, '')];
    }
}
